import React, { useEffect, useState } from "react";
import { Button, Modal, Table, Row, Col } from "react-bootstrap";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
import { Toaster, toast } from "sonner";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import axios from "axios";
import { MdDeleteOutline } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
const VehicleType = () => {
  const [show, setShow] = useState(false);
  const [editid, seteditid] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [vehicleTypes, setVehicleTypes] = useState([]);

  const getVehicle = async () => {
    try {
      let res = await axios.get(
        "https://vrpmpro.com/api/admin/vehicle-types"
      );
      if (res.status == 200) {
        setVehicleTypes(res.data.vehicleTypes);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getVehicle();
  }, []);

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing {from} to {to} of {size} Results
    </span>
  );
const { SearchBar, ClearSearchButton } = Search;
  const { ExportCSVButton } = CSVExport;
  const options = {
    paginationSize: 4,
    pageStartIndex: 0,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "All",
        value: vehicleTypes?.length || 0,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };
  const [typeName, setTypeName] = useState("");
  const [description, setDescription] = useState("");
  const [typeImage, setTypeImage] = useState(null);
  const [price, setPrice] = useState("");
  const [gst, setGst] = useState("");
  const [perkmprice, setperkmprice] = useState("");
  const [editShow, seteditshow] = useState(false);

  const [deleteId, setdeleteId] = useState("");
  const [showD, setshowD] = useState(false);
  const deleteVehicle = async () => {
    try {
      let res = await axios.delete(
        `https://vrpmpro.com/api/admin/vehicle-types/${deleteId}`
      );
      if (res.status === 200) {
        setshowD(false);
        getVehicle();
        toast.success("Successfully deleted")
      }
    } catch (error) {
      console.log(error);
    }
  };
  const columns = [
    {
      dataField: "sno",
      text: "S.No",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return <div>{rowIndex + 1}</div>;
      },
    },
    {
      dataField: "typeImage",
      text: "Vehicle Images",
      formatter: (cell, row, rowIndex) => {
        return (
          <div>
            {row?.typeImage && (
              <img
                src={`https://vrpmpro.com/vehicletypes/${row?.typeImage}`}
                style={{ width: "100px", height: "auto", borderRadius: "10px" }}
                alt={row?.typeName}
              />
            )}
          </div>
        );
      },
    },
    {
      dataField: "typeName",
      text: "Vehicle Type",
    },
    {
      dataField: "price",
      text: "Vehicle Base Price",
      sort: true,
    },
    {
      dataField: "perkmprice",
      text: "Per Km Price",
      sort: true,
    },
    {
      dataField: "gst",
      text: "Vehicle GST%",
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => {
        return (
          <div className="d-flex gap-2">
            <abbr
              title="Edit"
              className="btn btn-outline-primary"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setTypeName(row?.typeName);
                setDescription(row?.description);
                setPrice(row?.price);
                setGst(row?.gst);
                seteditid(row?._id);
                setperkmprice(row?.perkmprice);
                seteditshow(true);
              }}
            >
              <FaEdit size={25} />
            </abbr>
            <abbr
              title="Delete"
              className="btn btn-outline-danger"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setdeleteId(row?._id);
                setshowD(true);
              }}
            >
              <MdDeleteOutline size={25} />
            </abbr>
          </div>
        );
      },
    },
  ];
  const defaultSorted = [
    {
      dataField: "propertytype",
      order: "desc",
    },
  ];

  const handleImageChange = (e) => {
    setTypeImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    console.log("Form submitted!");
    console.log("Form values:", { typeName, description, typeImage, price, gst, perkmprice });
    console.log("vehicleTypes state:", vehicleTypes);
    
    // Validation
    if (!typeName || !description || !typeImage || !price || !gst || !perkmprice) {
      console.log("Validation failed - missing fields");
      toast.error("Please fill all required fields");
      return;
    }

    // Check for duplicates - handle undefined vehicleTypes
    let check = (vehicleTypes || []).filter(
      (ele) => ele?.typeName == typeName && ele?.description == description
    );
    if (check.length != 0) {
      console.log("Duplicate vehicle type found");
      return toast.error("Type of Vehicle already exits");
    }

    // Prepare form data
    const formData = new FormData();
    formData.append("typeName", typeName);
    formData.append("description", description);
    formData.append("typeImage", typeImage);
    formData.append("price", price);
    formData.append("gst", gst);
    formData.append("perkmprice", perkmprice);
    
    console.log("FormData prepared, making API call...");
    
    try {
      // Show loading toast
      const loadingToast = toast.loading("Adding vehicle type...");
      
      // Make API call to backend
      const response = await axios.post(
        "https://vrpmpro.com/api/admin/vehicle-types",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      
      // Dismiss loading toast
      toast.dismiss(loadingToast);
      
      // Handle response from the API
      console.log("Response:", response.data);
      toast.success("Vehicle type added successfully!");
      handleClose();
      setTypeName("");
      setDescription("");
      setPrice("");
      setGst("");
      setTypeImage(null);
      setperkmprice("");
      getVehicle();
    } catch (error) {
      // Handle errors
      console.error("Error submitting form:", error);
      console.error("Error response:", error.response?.data);
      console.error("Error status:", error.response?.status);
      
      if (error.response) {
        // Server responded with error
        toast.error(error.response.data?.message || `Server error: ${error.response.status}`);
      } else if (error.request) {
        // Request made but no response
        console.error("No response received:", error.request);
        toast.error("No response from server. Please check your connection.");
      } else {
        // Something else happened
        console.error("Error message:", error.message);
        toast.error("Error submitting form. Please try again.");
      }
    }
  };

  const handleEdit = async (e) => {
    e.preventDefault();

    console.log("Edit form submitted!");
    console.log("Edit values:", { typeName, description, typeImage, price, gst, perkmprice, editid });
    
    // Validation
    if (!typeName || !description || !price || !gst || !perkmprice) {
      toast.error("Please fill all required fields");
      return;
    }

    // Check for duplicates - handle undefined vehicleTypes
    let check = (vehicleTypes || []).filter(
      (ele) =>
        ele?.typeName == typeName &&
        ele?.description == description &&
        ele?._id != editid
    );
    if (check.length != 0) return toast.error("Type of Vehicle already exits");

    // Prepare form data
    const formData = new FormData();
    formData.append("typeName", typeName);
    formData.append("description", description);
    if (typeImage) {
      formData.append("typeImage", typeImage);
    }
    formData.append("price", price);
    formData.append("gst", gst);
    formData.append("perkmprice", perkmprice);
    
    console.log("Edit FormData prepared, making API call...");
    
    try {
      // Show loading toast
      const loadingToast = toast.loading("Updating vehicle type...");
      
      // Make API call to backend
      const response = await axios.put(
        "https://vrpmpro.com/api/admin/vehicle-types/" + editid,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      
      // Dismiss loading toast
      toast.dismiss(loadingToast);
      
      // Handle response from the API
      console.log("Edit Response:", response.data);
      toast.success("Vehicle type updated successfully!");
      seteditshow(false);
      setTypeName("");
      setDescription("");
      setPrice("");
      setGst("");
      setTypeImage(null);
      setperkmprice("");
      getVehicle();
    } catch (error) {
      // Handle errors
      console.error("Error updating form:", error);
      console.error("Error response:", error.response?.data);
      
      if (error.response) {
        // Server responded with error
        toast.error(error.response.data?.message || "Server error. Please try again.");
      } else if (error.request) {
        // Request made but no response
        toast.error("No response from server. Please check your connection.");
      } else {
        // Something else happened
        toast.error("Error updating form. Please try again.");
      }
    }
  };

  return (
    <div className="ml-4">
      <Toaster position="top-center" />
      <h1 className="pt-4 pb-3" style={{ color: "white" }}>
        Vehicle Type
      </h1>
      <div className="container">
        <div className="card card-body">
          <ToolkitProvider
            keyField="_id"
            data={vehicleTypes || []}
            columns={columns}
            defaultSorted={defaultSorted}
            search
            exportCSV={{
              fileName: "properties.csv",
              blobType: "text/csv;charset=ansi",
            }}
          >
            {(props) => (
              <div>
                <span className="pr-5 mr-auto">
                  <ExportCSVButton
                    className="btn-outline-success"
                    {...props.csvProps}
                  >
                    Export to CSV
                  </ExportCSVButton>
                </span>
                {"     "}
                <span className="ps-5 ml-5 mt-3">
                  <SearchBar className="form-control " {...props.searchProps} />
                </span>
                {"      "}
                <ClearSearchButton
                  className="btn-outline-info ms-5 "
                  {...props.searchProps}
                />
                <span className="ps-5 ml-5 mt-3">
                  <button
                    className="btn btn-outline-danger"
                    onClick={handleShow}
                  >
                    Add Vehicle Type
                  </button>
                </span>

                <hr />
                <div className="table-responsive">
                  <BootstrapTable
                    keyField="_id"
                    responsive
                    hover
                    columns={columns}
                    data={vehicleTypes || []}
                    pagination={paginationFactory(options)}
                    {...props.baseProps}
                  />
                </div>
              </div>
            )}
          </ToolkitProvider>
        </div>
      </div>
      {/* Modal */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Vehicle Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="container mt-2">
            <form onSubmit={handleSubmit}>
              <div class="mb-3">
                <label for="typeName" class="form-label">
                  Vehicle Type
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="typeName"
                  value={typeName}
                  placeholder="Enter type name (e.g., Mini Truck, Tempo)"
                  required
                  onChange={(e) => setTypeName(e.target.value)}
                />
              </div>

              <div class="mb-3">
                <label for="description" class="form-label">
                  Description
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Ex- 3 Wheeler (5.5 ft)"
                />
              </div>

              <div class="mb-3">
                <label for="typeImage" class="form-label">
                  Vehicle Image
                </label>
                <input
                  type="file"
                  class="form-control"
                  id="typeImage"
                  required
                  accept="image/*"
                  onChange={handleImageChange}
                />
              </div>

              <div class="mb-3">
                <label for="price" class="form-label">
                  Base Price
                </label>
                <input
                  type="number"
                  class="form-control"
                  id="price"
                  placeholder="Enter base price"
                  min="0"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                />
              </div>
              <div class="mb-3">
                <label for="perkmprice" class="form-label">
                  Per km Price
                </label>
                <input
                  type="number"
                  class="form-control"
                  id="perkmprice"
                  placeholder="Enter per km price"
                  min="0"
                  value={perkmprice}
                  onChange={(e) => setperkmprice(e.target.value)}
                />
              </div>

              <div class="mb-3">
                <label for="gst" class="form-label">
                  GST%
                </label>
                <input
                  type="number"
                  class="form-control"
                  id="gst"
                  placeholder="Enter GST ex:- 18%"
                  min="0"
                  value={gst}
                  onChange={(e) => setGst(e.target.value)}
                />
              </div>

              <button type="submit" class="btn btn-outline-success">
                Submit
              </button>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-outline-danger" onClick={handleClose}>
            Close
          </button>
          {/* <button className="btn btn-outline-success" onClick={handleClose}>
                        Save Changes
                    </button> */}
        </Modal.Footer>
      </Modal>

      {/* Modal */}
      <Modal show={editShow} onHide={() => seteditshow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Vehicle Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="container mt-2">
            <form onSubmit={handleEdit}>
              <div class="mb-3">
                <label for="typeName1" class="form-label">
                  Vehicle Type
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="typeName1"
                  value={typeName}
                  placeholder="Enter type name (e.g., Mini Truck, Tempo)"
                  required
                  onChange={(e) => setTypeName(e.target.value)}
                />
              </div>

              <div class="mb-3">
                <label for="description1" class="form-label">
                  Description
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="description1"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Ex- 3 Wheeler (5.5 ft)"
                />
              </div>

              <div class="mb-3">
                <label for="typeImage1" class="form-label">
                  Vehicle Image
                </label>
                <input
                  type="file"
                  class="form-control"
                  id="typeImage1"
                  accept="image/*"
                  onChange={handleImageChange}
                />
              </div>

              <div class="mb-3">
                <label for="price1" class="form-label">
                  Base Price
                </label>
                <input
                  type="number"
                  class="form-control"
                  id="price1"
                  placeholder="Enter base price"
                  min="0"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                />
              </div>
              <div class="mb-3">
                <label for="perkmprice1" class="form-label">
                  Per Km Price
                </label>
                <input
                  type="number"
                  class="form-control"
                  id="perkmprice1"
                  placeholder="Enter Per Km Price"
                  min="0"
                  value={perkmprice}
                  onChange={(e) => setperkmprice(e.target.value)}
                />
              </div>

              <div class="mb-3">
                <label for="gst1" class="form-label">
                  GST%
                </label>
                <input
                  type="number"
                  class="form-control"
                  id="gst1"
                  placeholder="Enter GST ex:- 18"
                  min="0"
                  value={gst}
                  onChange={(e) => setGst(e.target.value)}
                />
              </div>

              <button type="submit" class="btn btn-outline-success">
                Save Changes
              </button>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-outline-danger"
            onClick={() => seteditshow(false)}
          >
            Close
          </button>
          {/* <button className="btn btn-outline-success" onClick={handleClose}>
                        Save Changes
                    </button> */}
        </Modal.Footer>
      </Modal>

       {/* Modal */}
       <Modal show={showD} onHide={() => setshowD(false)} size="sm">
        <Modal.Header closeButton>
          <Modal.Title>Are you sure delete!</Modal.Title>
        </Modal.Header>
    
        <Modal.Footer>
          <button
            className="btn btn-outline-danger"
            onClick={() => setshowD(false)}
          >
            Cancel
          </button>
          <button className="btn btn-outline-success" onClick={deleteVehicle}>
                        Ok
                    </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default VehicleType;
